import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { SurveyDetailPage } from '@/features/surveys/pages/SurveyDetailPage';

export const Route = createFileRoute('/_auth/feedback/surveys/$surveyId/')({
  parseParams: ({ surveyId }) => {
    const parsedId = Number(surveyId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { surveyId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="Survey Detail">
      <SurveyDetailPage />
    </ErrorBoundary>
  ),
});
